import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function workOrderSafteyNetBuilder({parsedStatusObj}) {
  const { firstBidAsk, currentBidAsk, safetyNetPct, bidAskType } =
    parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        {safetyNetPct ? ApplyRounding(Number(safetyNetPct), 2) * 100 + '%' : ''}{' '}
        Work order limit reached. Starting {bidAskType ? bidAskType : 'bid/ask'}
        :{' '}
        {firstBidAsk ? '$' + ApplyRounding(Number(firstBidAsk), 2) : 'unknown'}.
        Current {bidAskType ? bidAskType : 'bid/ask'}:
        {currentBidAsk
          ? '$' + ApplyRounding(Number(currentBidAsk), 2)
          : 'unknown'}
        .
      </Body3>
    </td>
  );
}
